import { PasswordRegex, PasswordStrengthType, PasswordStrengthResult } from "../../../../model/common/password";

export class PasswordStrengthService {

    private PasswordStrengthResult: PasswordStrengthResult;
    private Password: string;
    private ConfirmPassword: string

    public static $inject: Array<string> = [];
    constructor() {
        this.PasswordStrengthResult = new PasswordStrengthResult();
        this.Password = "";
        this.ConfirmPassword = "";
    }

    public Validate(password: string = "", confirmPassword: string = ""): PasswordStrengthResult {
        this.PasswordStrengthResult = new PasswordStrengthResult();
        this.Password = password;
        this.ConfirmPassword = confirmPassword;

        if (PasswordRegex.LENGTH.test(password))
            this.PasswordStrengthResult.LengthValidated = true;

        let count = this.getCharacterPatternMatchCount(password);
        switch (count) {
            case 0:
            case 1:
            case 2: {
                this.PasswordStrengthResult.PasswordStrengthType = PasswordStrengthType.Weak;
                break;
            }
            case 3: {
                this.PasswordStrengthResult.CharacterPatternValidated = true;
                this.PasswordStrengthResult.PasswordStrengthType = PasswordStrengthType.Medium;
                break;
            }
            case 4: {
                this.PasswordStrengthResult.CharacterPatternValidated = true;
                this.PasswordStrengthResult.PasswordStrengthType = PasswordStrengthType.Strong;
                break;
            }
            default:
                break;
        }

        if (!this.PasswordStrengthResult.LengthValidated)
            this.PasswordStrengthResult.PasswordStrengthType = PasswordStrengthType.Weak;

        if (this.Password === this.ConfirmPassword)
            this.PasswordStrengthResult.ConFirmPasswordValidated = true;

        if (this.PasswordStrengthResult.PasswordStrengthType != PasswordStrengthType.Weak && this.PasswordStrengthResult.ConFirmPasswordValidated) {
            this.PasswordStrengthResult.Status = true;
        }

        return this.PasswordStrengthResult;
    }

    getCharacterPatternMatchCount(value: string): number {
        let matchedCriteriaCount: number = 0;
        if (PasswordRegex.DIGIT.test(value)) {
            matchedCriteriaCount++;
            this.PasswordStrengthResult.NumberCharacterPatternValidated = true;
        }
        if (PasswordRegex.LOWERCASEALPHABET.test(value)) {
            matchedCriteriaCount++;
            this.PasswordStrengthResult.LowerCasePatternValidated = true;
        }
        if (PasswordRegex.UPPERCASEALPHABET.test(value)) {
            matchedCriteriaCount++;
            this.PasswordStrengthResult.UpperCasePatternValidated = true;
        }
        //Check for Special Character
        if (value && !PasswordRegex.ALPHANUMERIC.test(value)) {
            matchedCriteriaCount++;
            this.PasswordStrengthResult.SpecialCharacterPatternValidated = true;
        }
        return matchedCriteriaCount;
    }
}